import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from '@/api/index.js';
import './service/index.js';
import '@/directives/importDirectives.js';  

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$api = api;

function setTitle(meta) {
  window.document.title = meta.title;
}

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('clock_in_token');
  const {
    meta,
    meta: { needLogin },
  } = to;
  if (needLogin) {
    if (token) {
      setTitle(meta);
      next();
    } else {
      setTitle(meta);
      next({
        path: '/login',
      });
    }
  } else {
    setTitle(meta);
    next();
  }
});
window.$vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
